import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _404dbc2e = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\index.vue' /* webpackChunkName: "pages/account/index" */))
const _94dbb762 = () => interopDefault(import('..\\..\\..\\src\\pages\\catalogues\\index.vue' /* webpackChunkName: "pages/catalogues/index" */))
const _cd73b372 = () => interopDefault(import('..\\..\\..\\src\\pages\\home-two.vue' /* webpackChunkName: "pages/home-two" */))
const _3340fa62 = () => interopDefault(import('..\\..\\..\\src\\pages\\offcanvas-cart.vue' /* webpackChunkName: "pages/offcanvas-cart" */))
const _c70c9478 = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\addresses\\index.vue' /* webpackChunkName: "pages/account/addresses/index" */))
const _288b1431 = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\customers.vue' /* webpackChunkName: "pages/account/customers" */))
const _7d984af0 = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\dashboard.vue' /* webpackChunkName: "pages/account/dashboard" */))
const _2f696f61 = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\employees.vue' /* webpackChunkName: "pages/account/employees" */))
const _c311994e = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\feedback.vue' /* webpackChunkName: "pages/account/feedback" */))
const _09f55f45 = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\login.vue' /* webpackChunkName: "pages/account/login" */))
const _fc70dc44 = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\logout.vue' /* webpackChunkName: "pages/account/logout" */))
const _74d22eae = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\orders\\index.vue' /* webpackChunkName: "pages/account/orders/index" */))
const _2721876f = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\password.vue' /* webpackChunkName: "pages/account/password" */))
const _2a81c176 = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\postings.vue' /* webpackChunkName: "pages/account/postings" */))
const _5d477885 = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\profile.vue' /* webpackChunkName: "pages/account/profile" */))
const _6b762f68 = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\sales.vue' /* webpackChunkName: "pages/account/sales" */))
const _23e9b4bd = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\userlist.vue' /* webpackChunkName: "pages/account/userlist" */))
const _8dadd3e4 = () => interopDefault(import('..\\..\\..\\src\\pages\\blog\\category-classic.vue' /* webpackChunkName: "pages/blog/category-classic" */))
const _f734dd0c = () => interopDefault(import('..\\..\\..\\src\\pages\\blog\\category-grid.vue' /* webpackChunkName: "pages/blog/category-grid" */))
const _2216cc6c = () => interopDefault(import('..\\..\\..\\src\\pages\\blog\\category-left-sidebar.vue' /* webpackChunkName: "pages/blog/category-left-sidebar" */))
const _7cb56a5c = () => interopDefault(import('..\\..\\..\\src\\pages\\blog\\category-list.vue' /* webpackChunkName: "pages/blog/category-list" */))
const _047ba030 = () => interopDefault(import('..\\..\\..\\src\\pages\\blog\\post-classic.vue' /* webpackChunkName: "pages/blog/post-classic" */))
const _99fa553e = () => interopDefault(import('..\\..\\..\\src\\pages\\blog\\post-full.vue' /* webpackChunkName: "pages/blog/post-full" */))
const _7970c7f9 = () => interopDefault(import('..\\..\\..\\src\\pages\\news\\category-left-sidebar.vue' /* webpackChunkName: "pages/news/category-left-sidebar" */))
const _692f26bf = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\cart.vue' /* webpackChunkName: "pages/shop/cart" */))
const _3c05f978 = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\catalog\\index.vue' /* webpackChunkName: "pages/shop/catalog/index" */))
const _7d391eeb = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\category-grid-3-columns-sidebar.vue' /* webpackChunkName: "pages/shop/category-grid-3-columns-sidebar" */))
const _193da42f = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\category-grid-4-columns-full.vue' /* webpackChunkName: "pages/shop/category-grid-4-columns-full" */))
const _4460f364 = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\category-grid-5-columns-full.vue' /* webpackChunkName: "pages/shop/category-grid-5-columns-full" */))
const _8cebd204 = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\category-list.vue' /* webpackChunkName: "pages/shop/category-list" */))
const _ac8cb00a = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\category-right-sidebar.vue' /* webpackChunkName: "pages/shop/category-right-sidebar" */))
const _ef91a306 = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\checkout\\index.vue' /* webpackChunkName: "pages/shop/checkout/index" */))
const _816e0ad4 = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\compare.vue' /* webpackChunkName: "pages/shop/compare" */))
const _671103c4 = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\product-columnar.vue' /* webpackChunkName: "pages/shop/product-columnar" */))
const _563bfcaf = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\product-sidebar.vue' /* webpackChunkName: "pages/shop/product-sidebar" */))
const _033d757a = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\product-standard.vue' /* webpackChunkName: "pages/shop/product-standard" */))
const _3a6f65fd = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\track-order.vue' /* webpackChunkName: "pages/shop/track-order" */))
const _1422ab64 = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\wishlist.vue' /* webpackChunkName: "pages/shop/wishlist" */))
const _71139ee4 = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\about-us.vue' /* webpackChunkName: "pages/site/about-us" */))
const _7bbc64c6 = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\components.vue' /* webpackChunkName: "pages/site/components" */))
const _750562ca = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\contact-us.vue' /* webpackChunkName: "pages/site/contact-us" */))
const _4578f577 = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\contact-us-alt.vue' /* webpackChunkName: "pages/site/contact-us-alt" */))
const _528955e8 = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\create-account.vue' /* webpackChunkName: "pages/site/create-account" */))
const _d1e678d4 = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\faq.vue' /* webpackChunkName: "pages/site/faq" */))
const _ca0cb896 = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\feedback.vue' /* webpackChunkName: "pages/site/feedback" */))
const _1527c253 = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\forgot.vue' /* webpackChunkName: "pages/site/forgot" */))
const _fb2864f0 = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\not-found.vue' /* webpackChunkName: "pages/site/not-found" */))
const _08b9803e = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\request-quote.vue' /* webpackChunkName: "pages/site/request-quote" */))
const _610ef74f = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\reset.vue' /* webpackChunkName: "pages/site/reset" */))
const _624a4787 = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\terms.vue' /* webpackChunkName: "pages/site/terms" */))
const _98a4bb42 = () => interopDefault(import('..\\..\\..\\src\\pages\\site\\typography.vue' /* webpackChunkName: "pages/site/typography" */))
const _0b24e724 = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\checkout\\success.vue' /* webpackChunkName: "pages/shop/checkout/success" */))
const _69fdfdb9 = () => interopDefault(import('..\\..\\..\\src\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _53c2592c = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\addresses\\_id.vue' /* webpackChunkName: "pages/account/addresses/_id" */))
const _282dfd5e = () => interopDefault(import('..\\..\\..\\src\\pages\\account\\orders\\_id.vue' /* webpackChunkName: "pages/account/orders/_id" */))
const _5a3cd2ef = () => interopDefault(import('..\\..\\..\\src\\pages\\blog\\post\\_slug.vue' /* webpackChunkName: "pages/blog/post/_slug" */))
const _40251fde = () => interopDefault(import('..\\..\\..\\src\\pages\\news\\post\\_slug.vue' /* webpackChunkName: "pages/news/post/_slug" */))
const _3a4f5830 = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\catalog\\_slug.vue' /* webpackChunkName: "pages/shop/catalog/_slug" */))
const _272a3610 = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\draftcart\\_id.vue' /* webpackChunkName: "pages/shop/draftcart/_id" */))
const _b7f22b52 = () => interopDefault(import('..\\..\\..\\src\\pages\\shop\\products\\_slug.vue' /* webpackChunkName: "pages/shop/products/_slug" */))
const _9848f9f2 = () => interopDefault(import('..\\..\\..\\src\\pages\\catalogues\\_slug.vue' /* webpackChunkName: "pages/catalogues/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _404dbc2e,
    name: "account"
  }, {
    path: "/catalogues",
    component: _94dbb762,
    name: "catalogues"
  }, {
    path: "/home-two",
    component: _cd73b372,
    name: "home-two"
  }, {
    path: "/offcanvas-cart",
    component: _3340fa62,
    name: "offcanvas-cart"
  }, {
    path: "/account/addresses",
    component: _c70c9478,
    name: "account-addresses"
  }, {
    path: "/account/customers",
    component: _288b1431,
    name: "account-customers"
  }, {
    path: "/account/dashboard",
    component: _7d984af0,
    name: "account-dashboard"
  }, {
    path: "/account/employees",
    component: _2f696f61,
    name: "account-employees"
  }, {
    path: "/account/feedback",
    component: _c311994e,
    name: "account-feedback"
  }, {
    path: "/account/login",
    component: _09f55f45,
    name: "account-login"
  }, {
    path: "/account/logout",
    component: _fc70dc44,
    name: "account-logout"
  }, {
    path: "/account/orders",
    component: _74d22eae,
    name: "account-orders"
  }, {
    path: "/account/password",
    component: _2721876f,
    name: "account-password"
  }, {
    path: "/account/postings",
    component: _2a81c176,
    name: "account-postings"
  }, {
    path: "/account/profile",
    component: _5d477885,
    name: "account-profile"
  }, {
    path: "/account/sales",
    component: _6b762f68,
    name: "account-sales"
  }, {
    path: "/account/userlist",
    component: _23e9b4bd,
    name: "account-userlist"
  }, {
    path: "/blog/category-classic",
    component: _8dadd3e4,
    name: "blog-category-classic"
  }, {
    path: "/blog/category-grid",
    component: _f734dd0c,
    name: "blog-category-grid"
  }, {
    path: "/blog/category-left-sidebar",
    component: _2216cc6c,
    name: "blog-category-left-sidebar"
  }, {
    path: "/blog/category-list",
    component: _7cb56a5c,
    name: "blog-category-list"
  }, {
    path: "/blog/post-classic",
    component: _047ba030,
    name: "blog-post-classic"
  }, {
    path: "/blog/post-full",
    component: _99fa553e,
    name: "blog-post-full"
  }, {
    path: "/news/category-left-sidebar",
    component: _7970c7f9,
    name: "news-category-left-sidebar"
  }, {
    path: "/shop/cart",
    component: _692f26bf,
    name: "shop-cart"
  }, {
    path: "/shop/catalog",
    component: _3c05f978,
    name: "shop-catalog"
  }, {
    path: "/shop/category-grid-3-columns-sidebar",
    component: _7d391eeb,
    name: "shop-category-grid-3-columns-sidebar"
  }, {
    path: "/shop/category-grid-4-columns-full",
    component: _193da42f,
    name: "shop-category-grid-4-columns-full"
  }, {
    path: "/shop/category-grid-5-columns-full",
    component: _4460f364,
    name: "shop-category-grid-5-columns-full"
  }, {
    path: "/shop/category-list",
    component: _8cebd204,
    name: "shop-category-list"
  }, {
    path: "/shop/category-right-sidebar",
    component: _ac8cb00a,
    name: "shop-category-right-sidebar"
  }, {
    path: "/shop/checkout",
    component: _ef91a306,
    name: "shop-checkout"
  }, {
    path: "/shop/compare",
    component: _816e0ad4,
    name: "shop-compare"
  }, {
    path: "/shop/product-columnar",
    component: _671103c4,
    name: "shop-product-columnar"
  }, {
    path: "/shop/product-sidebar",
    component: _563bfcaf,
    name: "shop-product-sidebar"
  }, {
    path: "/shop/product-standard",
    component: _033d757a,
    name: "shop-product-standard"
  }, {
    path: "/shop/track-order",
    component: _3a6f65fd,
    name: "shop-track-order"
  }, {
    path: "/shop/wishlist",
    component: _1422ab64,
    name: "shop-wishlist"
  }, {
    path: "/site/about-us",
    component: _71139ee4,
    name: "site-about-us"
  }, {
    path: "/site/components",
    component: _7bbc64c6,
    name: "site-components"
  }, {
    path: "/site/contact-us",
    component: _750562ca,
    name: "site-contact-us"
  }, {
    path: "/site/contact-us-alt",
    component: _4578f577,
    name: "site-contact-us-alt"
  }, {
    path: "/site/create-account",
    component: _528955e8,
    name: "site-create-account"
  }, {
    path: "/site/faq",
    component: _d1e678d4,
    name: "site-faq"
  }, {
    path: "/site/feedback",
    component: _ca0cb896,
    name: "site-feedback"
  }, {
    path: "/site/forgot",
    component: _1527c253,
    name: "site-forgot"
  }, {
    path: "/site/not-found",
    component: _fb2864f0,
    name: "site-not-found"
  }, {
    path: "/site/request-quote",
    component: _08b9803e,
    name: "site-request-quote"
  }, {
    path: "/site/reset",
    component: _610ef74f,
    name: "site-reset"
  }, {
    path: "/site/terms",
    component: _624a4787,
    name: "site-terms"
  }, {
    path: "/site/typography",
    component: _98a4bb42,
    name: "site-typography"
  }, {
    path: "/shop/checkout/success",
    component: _0b24e724,
    name: "shop-checkout-success"
  }, {
    path: "/",
    component: _69fdfdb9,
    name: "index"
  }, {
    path: "/account/addresses/:id",
    component: _53c2592c,
    name: "account-addresses-id"
  }, {
    path: "/account/orders/:id",
    component: _282dfd5e,
    name: "account-orders-id"
  }, {
    path: "/blog/post/:slug?",
    component: _5a3cd2ef,
    name: "blog-post-slug"
  }, {
    path: "/news/post/:slug?",
    component: _40251fde,
    name: "news-post-slug"
  }, {
    path: "/shop/catalog/:slug",
    component: _3a4f5830,
    name: "shop-catalog-slug"
  }, {
    path: "/shop/draftcart/:id?",
    component: _272a3610,
    name: "shop-draftcart-id"
  }, {
    path: "/shop/products/:slug?",
    component: _b7f22b52,
    name: "shop-products-slug"
  }, {
    path: "/catalogues/:slug",
    component: _9848f9f2,
    name: "catalogues-slug"
  }, {
    path: "/:lang/account",
    component: _404dbc2e,
    name: "lang-account"
  }, {
    path: "/:lang/catalogues",
    component: _94dbb762,
    name: "lang-catalogues"
  }, {
    path: "/:lang/home-two",
    component: _cd73b372,
    name: "lang-home-two"
  }, {
    path: "/:lang/offcanvas-cart",
    component: _3340fa62,
    name: "lang-offcanvas-cart"
  }, {
    path: "/:lang/account/addresses",
    component: _c70c9478,
    name: "lang-account-addresses"
  }, {
    path: "/:lang/account/customers",
    component: _288b1431,
    name: "lang-account-customers"
  }, {
    path: "/:lang/account/dashboard",
    component: _7d984af0,
    name: "lang-account-dashboard"
  }, {
    path: "/:lang/account/employees",
    component: _2f696f61,
    name: "lang-account-employees"
  }, {
    path: "/:lang/account/feedback",
    component: _c311994e,
    name: "lang-account-feedback"
  }, {
    path: "/:lang/account/login",
    component: _09f55f45,
    name: "lang-account-login"
  }, {
    path: "/:lang/account/logout",
    component: _fc70dc44,
    name: "lang-account-logout"
  }, {
    path: "/:lang/account/orders",
    component: _74d22eae,
    name: "lang-account-orders"
  }, {
    path: "/:lang/account/password",
    component: _2721876f,
    name: "lang-account-password"
  }, {
    path: "/:lang/account/postings",
    component: _2a81c176,
    name: "lang-account-postings"
  }, {
    path: "/:lang/account/profile",
    component: _5d477885,
    name: "lang-account-profile"
  }, {
    path: "/:lang/account/sales",
    component: _6b762f68,
    name: "lang-account-sales"
  }, {
    path: "/:lang/account/userlist",
    component: _23e9b4bd,
    name: "lang-account-userlist"
  }, {
    path: "/:lang/blog/category-classic",
    component: _8dadd3e4,
    name: "lang-blog-category-classic"
  }, {
    path: "/:lang/blog/category-grid",
    component: _f734dd0c,
    name: "lang-blog-category-grid"
  }, {
    path: "/:lang/blog/category-left-sidebar",
    component: _2216cc6c,
    name: "lang-blog-category-left-sidebar"
  }, {
    path: "/:lang/blog/category-list",
    component: _7cb56a5c,
    name: "lang-blog-category-list"
  }, {
    path: "/:lang/blog/post-classic",
    component: _047ba030,
    name: "lang-blog-post-classic"
  }, {
    path: "/:lang/blog/post-full",
    component: _99fa553e,
    name: "lang-blog-post-full"
  }, {
    path: "/:lang/news/category-left-sidebar",
    component: _7970c7f9,
    name: "lang-news-category-left-sidebar"
  }, {
    path: "/:lang/shop/cart",
    component: _692f26bf,
    name: "lang-shop-cart"
  }, {
    path: "/:lang/shop/catalog",
    component: _3c05f978,
    name: "lang-shop-catalog"
  }, {
    path: "/:lang/shop/category-grid-3-columns-sidebar",
    component: _7d391eeb,
    name: "lang-shop-category-grid-3-columns-sidebar"
  }, {
    path: "/:lang/shop/category-grid-4-columns-full",
    component: _193da42f,
    name: "lang-shop-category-grid-4-columns-full"
  }, {
    path: "/:lang/shop/category-grid-5-columns-full",
    component: _4460f364,
    name: "lang-shop-category-grid-5-columns-full"
  }, {
    path: "/:lang/shop/category-list",
    component: _8cebd204,
    name: "lang-shop-category-list"
  }, {
    path: "/:lang/shop/category-right-sidebar",
    component: _ac8cb00a,
    name: "lang-shop-category-right-sidebar"
  }, {
    path: "/:lang/shop/checkout",
    component: _ef91a306,
    name: "lang-shop-checkout"
  }, {
    path: "/:lang/shop/compare",
    component: _816e0ad4,
    name: "lang-shop-compare"
  }, {
    path: "/:lang/shop/product-columnar",
    component: _671103c4,
    name: "lang-shop-product-columnar"
  }, {
    path: "/:lang/shop/product-sidebar",
    component: _563bfcaf,
    name: "lang-shop-product-sidebar"
  }, {
    path: "/:lang/shop/product-standard",
    component: _033d757a,
    name: "lang-shop-product-standard"
  }, {
    path: "/:lang/shop/track-order",
    component: _3a6f65fd,
    name: "lang-shop-track-order"
  }, {
    path: "/:lang/shop/wishlist",
    component: _1422ab64,
    name: "lang-shop-wishlist"
  }, {
    path: "/:lang/site/about-us",
    component: _71139ee4,
    name: "lang-site-about-us"
  }, {
    path: "/:lang/site/components",
    component: _7bbc64c6,
    name: "lang-site-components"
  }, {
    path: "/:lang/site/contact-us",
    component: _750562ca,
    name: "lang-site-contact-us"
  }, {
    path: "/:lang/site/contact-us-alt",
    component: _4578f577,
    name: "lang-site-contact-us-alt"
  }, {
    path: "/:lang/site/create-account",
    component: _528955e8,
    name: "lang-site-create-account"
  }, {
    path: "/:lang/site/faq",
    component: _d1e678d4,
    name: "lang-site-faq"
  }, {
    path: "/:lang/site/feedback",
    component: _ca0cb896,
    name: "lang-site-feedback"
  }, {
    path: "/:lang/site/forgot",
    component: _1527c253,
    name: "lang-site-forgot"
  }, {
    path: "/:lang/site/not-found",
    component: _fb2864f0,
    name: "lang-site-not-found"
  }, {
    path: "/:lang/site/request-quote",
    component: _08b9803e,
    name: "lang-site-request-quote"
  }, {
    path: "/:lang/site/reset",
    component: _610ef74f,
    name: "lang-site-reset"
  }, {
    path: "/:lang/site/terms",
    component: _624a4787,
    name: "lang-site-terms"
  }, {
    path: "/:lang/site/typography",
    component: _98a4bb42,
    name: "lang-site-typography"
  }, {
    path: "/:lang/shop/checkout/success",
    component: _0b24e724,
    name: "lang-shop-checkout-success"
  }, {
    path: "/:lang/",
    component: _69fdfdb9,
    name: "lang-index"
  }, {
    path: "/:lang/account/addresses/:id",
    component: _53c2592c,
    name: "lang-account-addresses-id"
  }, {
    path: "/:lang/account/orders/:id",
    component: _282dfd5e,
    name: "lang-account-orders-id"
  }, {
    path: "/:lang/blog/post/:slug?",
    component: _5a3cd2ef,
    name: "lang-blog-post-slug"
  }, {
    path: "/:lang/news/post/:slug?",
    component: _40251fde,
    name: "lang-news-post-slug"
  }, {
    path: "/:lang/shop/catalog/:slug",
    component: _3a4f5830,
    name: "lang-shop-catalog-slug"
  }, {
    path: "/:lang/shop/draftcart/:id?",
    component: _272a3610,
    name: "lang-shop-draftcart-id"
  }, {
    path: "/:lang/shop/products/:slug?",
    component: _b7f22b52,
    name: "lang-shop-products-slug"
  }, {
    path: "/:lang/catalogues/:slug",
    component: _9848f9f2,
    name: "lang-catalogues-slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
